module.exports = __webpack_public_path__ + "static/how-it-works-banner.d849d153.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/banners/how-it-works-banner.jpg
// module id = 1459
// module chunks = 214286880276331